import { Settings } from '../core';
import { deserialize} from 'santee-dcts';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { Site } from './site';
import { SitesReadModel } from './sites-read.model';
import { Project } from '../admin/shared/project';

@Injectable()
export class InvestigatorSitesStorage {
    private sitesValue: Observable<Site[]> = null;

    constructor(
        private settings: Settings,
        private http: HttpClient
    ) { }

    public saveSiteIsFavorite(site: Site) {
        return this.http
            .post(`${this.settings.apiUrl}/investigator/sites/${site.siteId}/favorite/`, { isFavorite: !site.isFavorite });
    }

    public loadSites(reload: boolean = false): Observable<Site[]> {
        if (!this.sitesValue || reload) {
            this.sitesValue = this.http
                .get(`${this.settings.apiUrl}/investigator/sites`)
                .pipe(
                    map((rawStudies) => deserialize(rawStudies, SitesReadModel).sites),
                    publishLast(),
                    refCount()
                );
        }

        return this.sitesValue;
    }

    public getMultiSelectedProjectSites(projects: Project[]): Observable<Site[]> {
        const subProtocolIds = this.getSubProtocolIds(projects);

        return this.http.get(`${this.settings.apiUrl}/investigator/sites/allSelectedProjectsites`, { params: { subProtocolIds } })
            .pipe(map(sites => deserialize(sites, SitesReadModel).sites));
    }

    private getSubProtocolIds(projects: Project[]): string[] {
        let subProtocolIds: string[] = [];

        projects.forEach(project => {
            subProtocolIds.push(project.subProtocolId.toString());
        });

        return subProtocolIds;
    }
}